
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchInterface from "@/libs/model/MatchInterface";

@Component({})
export default class TeamsStage extends Vue
{
  name: 'TeamsStage';
  @Prop() matchdata: MatchInterface;
  @Prop({default:false}) hidematchname: boolean;
  get teamStage() {
    if(this.hidematchname){
      return "";
    }
    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Postponed"){
      if(this.matchdata.matchInfo && (!this.matchdata.matchInfo.date || this.matchdata.matchInfo.date === "")) {
        return "";
      }
    }

    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus === "Abandoned"){
      return "";
    }

    if(typeof(this.matchdata.matchInfo.series) !== 'undefined') {
      return this.matchdata.matchInfo.series.name;
    }else {
      return this.matchdata.matchInfo.stage.name;
    }
  }
}
